import AccountCircle from '@mui/icons-material/AccountCircle';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { AppBar, Avatar, Box, Button, Container, IconButton, Menu, MenuItem, Toolbar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png'; // Import the logo image
import { logout } from '../store/authSlice';
import { RootState } from '../store/store';
import ColorModeContext from './ui/ColorModeContext';

const NavigationBar: React.FC = () => {
  const navigate = useNavigate();
  const profile = useSelector((state: RootState) => state.auth.profile);
  const colorMode = React.useContext(ColorModeContext);
  const theme = useTheme();

  const handleLogout = () => {
    logout();
  };

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Link to="/">
            <Avatar alt="Logo" src={logo} sx={{ width: 'auto', marginRight: 2 }} />
          </Link>
          <Box sx={{ flexGrow: 1, display: 'flex' }}>
            {profile && profile.role.toLowerCase() === 'doctor' && (
              <Button
                color="inherit"
                onClick={() => {
                  navigate('/home');
                }}
              >
                Patients
              </Button>
            )}
            {profile && profile.role.toLowerCase() === 'admin' && (
              <div>
                <Button
                  color="inherit"
                  onClick={() => {
                    navigate('/admin/studies');
                  }}
                >
                  Etudes
                </Button>
                <Button
                  color="inherit"
                  onClick={() => {
                    navigate('/admin/hospitals');
                  }}
                >
                  Centres
                </Button>
                <Button
                  color="inherit"
                  onClick={() => {
                    navigate('/admin/health-professionals');
                  }}
                >
                  Professionels de Santé
                </Button>
                <Button
                  color="inherit"
                  onClick={() => {
                    navigate('/admin/patients');
                  }}
                >
                  Patients
                </Button>
                <Button
                  color="inherit"
                  onClick={() => {
                    navigate('/admin/events');
                  }}
                >
                  Evénements
                </Button>
                <Button
                  color="inherit"
                  onClick={() => {
                    navigate('/admin/activity');
                  }}
                >
                  Alertes
                </Button>
              </div>
            )}
          </Box>
          {profile && (
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <IconButton aria-controls="menu-appbar" aria-haspopup="true" color="inherit" onClick={handleOpenUserMenu} size="large" sx={{ p: 0 }}>
                <AccountCircle />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                id="menu-appbar"
                keepMounted
                onClose={handleCloseUserMenu}
                open={Boolean(anchorEl)}
                sx={{ mt: '45px' }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                <MenuItem
                  onClick={() => {
                    handleCloseUserMenu();
                    navigate('/profile');
                  }}
                >
                  Profile
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleCloseUserMenu();
                    handleLogout();
                  }}
                >
                  Logout
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleCloseUserMenu();
                  }}
                >
                  <IconButton color="inherit" onClick={colorMode.toggleColorMode} sx={{ ml: 1 }}>
                    {theme.palette.mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
                  </IconButton>
                </MenuItem>
              </Menu>
            </Box>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default NavigationBar;
